import React from 'react';

const SortableHeader = ({ label, field, currentSort, onSort }) => {
  const isActive = currentSort.field === field;
  const direction = isActive ? currentSort.direction : '';

  return (
    <th 
      className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
      onClick={() => {
        const newDirection = !isActive ? 'asc' : 
          direction === 'asc' ? 'desc' : 
          direction === 'desc' ? '' : 'asc';
        onSort({ field, direction: newDirection });
      }}
    >
      <div className="flex items-center space-x-1">
        <span>{label}</span>
        <span className="text-gray-400">
          {isActive && direction === 'asc' && '↑'}
          {isActive && direction === 'desc' && '↓'}
        </span>
      </div>
    </th>
  );
};

export default SortableHeader;
